/**
 * Whether two lists hold the same elements in the same order, each pair compared with `same`,
 * which is `===` unless given.
 */
export function sameElements(a, b, same = (x, y) => x === y) {
    return a.length === b.length && a.every((element, index) => same(element, b[index]));
}
//# sourceMappingURL=sameElements.js.map